import React from 'react';
import { useLanguage } from './Header';
import { useTranslation } from '../utils/translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = useTranslation(language);
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">{t('appName')}</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              {t('empoweringFarmers')} {t('growingTogether')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-dark-azure rounded-xl flex items-center justify-center hover:bg-azure-light transition-colors duration-300">
                <span className="text-sm font-bold">f</span>
              </a>
              <a href="#" className="w-10 h-10 bg-dark-azure rounded-xl flex items-center justify-center hover:bg-azure-light transition-colors duration-300">
                <span className="text-sm font-bold">t</span>
              </a>
              <a href="#" className="w-10 h-10 bg-dark-azure rounded-xl flex items-center justify-center hover:bg-azure-light transition-colors duration-300">
                <span className="text-sm font-bold">in</span>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('features')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('cropPredictionFooter')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('diseaseDetectionFooter')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('weatherInsights')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('soilAnalysis')}</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('support')}</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('helpCenter')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('tutorials')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('community')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors duration-300">{t('contact')}</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              {t('allRightsReserved')}
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors duration-300">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors duration-300">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;